import {
  getAnalytics,
  logEvent,
  setUserId,
  setUserProperties,
} from 'firebase/analytics';
import { getApps, initializeApp } from 'firebase/app';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import {
  getBrowserId,
  getContentType,
  getExperimentTypeOfUser,
  getScreenName,
  isProductionServer,
} from './helper';
import { getWebUserType } from './getWebUserType';

import { userDataFetcher } from '../datafetchers/productPage/userDataFetcher';
import { fireEvent } from './fireEvent';

export const firebaseConfig = {
  apiKey: 'AIzaSyBn2R61TEjNYU90KcC-6cQTQkg81tjYN88',
  authDomain: 'littleone-150007.firebaseapp.com',
  databaseURL: 'https://littleone-150007.firebaseio.com',
  //databaseURL: "https://littleone-150007-develop.firebaseio.com",
  projectId: 'littleone-150007',
  storageBucket: 'littleone-150007.appspot.com',
  messagingSenderId: '419607948821',
  appId: '1:419607948821:web:6dd68b32b2911222',
  measurementId: 'G-60ZE50WNKZ',
};
if (!getApps().length) {
  initializeApp(firebaseConfig);
}

// export const dbRef = ref(getDatabase());

// export const getValues = async (path, id) => {
//     const fetchedData = await get(child(dbRef, `${path}${id}`))
//         .then((snapshot) => {
//             if (snapshot.exists()) {
//                 return snapshot.val();
//             }
//         })
//         .catch((error) => {
//             console.error(error);
//         });
//     return fetchedData;
// };

// export const updateValuesInFireBaseDB = (updates) => {
//     if (updates) {
//         update(dbRef, updates).then(() => {
//             getValues();
//         });
//     }
// };

const setFirebaseUserProperty = async (analytics) => {
  let userType = getWebUserType();
  try {
    if (!Cookies.get('react_user_properties')) {
      const res = await userDataFetcher({ user_type: userType });
      let user_data = JSON.stringify(res.user);
      if (user_data) {
        Cookies.set('react_user_properties', user_data, '/');
        let data = JSON.parse(user_data);
        if (data?.language) {
          Cookies.set('language', data.language == 2 ? 'hi' : 'en', '/');
        }
      }
    }
  } catch (error) {
    console.error('Fetch user details failed, refresh page');
  }
  let userProperties;
  let deviceProperties;
  try {
    let data = JSON.parse(Cookies.get('react_user_properties'));
    let browser_id = getBrowserId();
    deviceProperties = {
      browser_id: browser_id,
      network_type: window?.navigator?.connection?.effectiveType,
      device: window?.navigator?.appVersion?.substring(0, 99),
      os: window?.navigator?.userAgent?.substring(0, 99),
    };

    if (data) {
      if (data?.user_id) setUserId(analytics, data?.user_id);
      userProperties = {
        login_type: data?.login_type,
        username: data?.username,
        email: data?.email,
        mobile: data?.mobile,
        language: data?.language,
      };
    }
  } catch (error) {
    console.error('data not found', error);
  }
  setUserProperties(analytics, { ...userProperties, ...deviceProperties });
};

export const useFireBaseApp = () => {
  useEffect(() => {
    const analytics = getAnalytics();
    setFirebaseUserProperty(analytics);
    getExperimentTypeOfUser();
  }, []);
};

export const fireGAEvent = (props) => {
  const analytics = getAnalytics();
  let data = props;
  const eventName = props.category;
  delete data['category'];
  if (isProductionServer()) {
    logEvent(analytics, eventName, data);
  } else {
    console.log('analyticsLogEvent', eventName, JSON.stringify(data));
  }
};

export const fireEventForRepeatUser = (screenType) => {
  if (!sessionStorage.getItem('user_session')) {
    sessionStorage.setItem('user_session', 'true');
    const current_sessions = Cookies.get('user_sessions')
      ? parseInt(Cookies.get('user_sessions'))
      : 0;
    Cookies.set('user_sessions', current_sessions + 1, '/');
  }
  const currentSession = Cookies.get('user_sessions')
    ? parseInt(Cookies.get('user_sessions'))
    : 0;
  const visitorSession = Cookies.get('visitor_session')
    ? parseInt(Cookies.get('visitor_session'))
    : 0;
  if (!visitorSession) {
    fireEvent({
      category: 'visitor',
      parent: 'new',
      support_variable: screenType,
    });
    Cookies.set('visitor_session', currentSession);
  } else if (currentSession - visitorSession == 1) {
    fireEvent({
      category: 'visitor',
      parent: 'repeat',
      support_variable: screenType,
    });
  }
};

export const fireViewedScreenEvent = (
  id = null,
  name = null,
  topicName = null,
  additionalEventData = {},
) => {
  let timeZone = '';
  if (Intl && Intl.DateTimeFormat)
    timeZone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone;
  else timeZone = 'NA';

  fireEvent({
    category: 'viewed_content_detail_page',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    content_type: getContentType(),
    content_id: id,
    name: name,
    parent: topicName,
    timeZone: timeZone,
    support_variable: id,
    ...additionalEventData,
  });
};
export const fireViewedGeneralScreenEvent = (id = null, name = null) => {
  fireEvent({
    category: 'viewed_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    content_type: getContentType(),
    content_id: id,
    name: name,
  });
};
export const fireServedSectionEvent = (sectionName, cardIDs, contentType) => {
  fireEvent({
    category: 'served_section_in_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    content_type: contentType ? contentType : getContentType(),
    section_name: sectionName,
    card_ids: cardIDs,
  });
};
export const fireClickedFollowEvent = (sectionName, deeplink) => {
  fireEvent({
    category: 'clicked_follow',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    section_name: sectionName,
    deeplink_value: deeplink,
    action: deeplink ? 'continue in app' : '',
  });
};
export const fireClickedCardEvent = (
  sectionName,
  cardName,
  contentType,
  cardId,
  deeplink,
  deeplinkValue,
  parentTag,
) => {
  fireEvent({
    category: 'clicked_card_in_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    content_type: contentType || parentTag,
    section_name: sectionName,
    card_name: cardName,
    card_id: cardId,
    deeplink_value: deeplinkValue || deeplink,
    action: deeplink && !parentTag ? 'continue in app' : '',
    parent: parentTag,
  });
};
export const fireClickedTabEvent = (tabName) => {
  fireEvent({
    category: 'clicked_subtab_in_general_screen',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    name: tabName,
  });
};
export const fireClickedCTAEvent = (sectionName, cta, contentType) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    page_url: window?.location?.href,
    content_type: contentType,
    section_name: sectionName,
    cta: cta,
  });
};
export const fireDownloadAppEvent = (deeplink) => {
  fireEvent({
    category: 'clicked_download_app',
    screen_name: getScreenName(),
    name: 'google_play',
    deeplink_value: deeplink,
    page_url: window?.location?.href,
  });
};
